import React, { useState } from "react";
import logo from "../assets/logo.png";
import leftimg from "../assets/creative_ux_illustration_tubik 1.png";
import { forgetPassword } from "../services/user.services";
import toast from "react-hot-toast";

const ForgetPassword = ({ onClose, onBack }) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    setIsLoading(true);

    try {
      const response = await forgetPassword({ email });
      toast.success("Password reset link sent to your email!");
      setIsEmailSent(true);
    } catch (error) {
      console.error("Forget password error:", error);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to send reset email. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToLogin = () => {
    setIsEmailSent(false);
    setEmail("");
    onBack();
  };

  return (
    <div className="flex items-center justify-center h-[100vh]">
      <div className="flex items-center justify-center border-solid border-2 border-gray-200 shadow-lg">
        {/* Left Side (Image/Illustration) */}
        <div className="hidden md:flex md:w-1/2 h-full bg-yellow-200 justify-center items-center">
          <img className="w-full h-full shadow-lg" src={leftimg} alt="" />
        </div>

        {/* Right Side (Forget Password Form) */}
        <div className="flex flex-col justify-center items-center md:w-1/2 w-full px-6 py-8">
          <div className="max-w-md w-full">
            <div className="flex justify-center mb-6">
              <img src={logo} alt="Logo" className="w-40 h-auto" />
            </div>

            {!isEmailSent ? (
              <>
                <h2 className="text-center text-3xl font-bold text-gray-800">
                  Forgot Password? 🔐
                </h2>
                <p className="text-center text-gray-500 mb-8">
                  Enter your email address and we'll send you a reset link
                </p>

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <input
                      name="email"
                      type="email"
                      placeholder="Enter your email address"
                      className="mt-1 px-3 py-2 border border-gray-300 w-full focus:outline-none focus:border-indigo-500"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={isLoading}
                    />
                  </div>

                  <div className="space-y-3">
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="w-full bg-indigo-600 text-white flex justify-center items-center py-2 px-4 hover:bg-indigo-700 focus:outline-none disabled:bg-indigo-400 disabled:cursor-not-allowed"
                    >
                      {isLoading ? "Sending..." : "Send Reset Link"}
                    </button>

                    <button
                      type="button"
                      onClick={handleBackToLogin}
                      className="w-full bg-gray-100 text-gray-700 flex justify-center items-center py-2 px-4 hover:bg-gray-200 focus:outline-none"
                    >
                      Back to Login
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <>
                <div className="text-center">
                  <div className="mb-4">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                      <svg
                        className="w-8 h-8 text-green-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                  </div>

                  <h2 className="text-2xl font-bold text-gray-800 mb-4">
                    Check Your Email! 📧
                  </h2>

                  <p className="text-gray-600 mb-6">
                    We've sent a password reset link to <strong>{email}</strong>
                    . Please check your inbox and follow the instructions to
                    reset your password.
                  </p>

                  <div className="space-y-3">
                    <button
                      onClick={() => {
                        setIsEmailSent(false);
                        setEmail("");
                      }}
                      className="w-full bg-indigo-600 text-white flex justify-center items-center py-2 px-4 hover:bg-indigo-700 focus:outline-none"
                    >
                      Send Another Email
                    </button>

                    <button
                      onClick={handleBackToLogin}
                      className="w-full bg-gray-100 text-gray-700 flex justify-center items-center py-2 px-4 hover:bg-gray-200 focus:outline-none"
                    >
                      Back to Login
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
